import { isEmpty } from 'lodash';
import i18next from 'i18next';
import React from 'react';

import { Button } from '@commons/utils/styledLibraryComponents';
import { isUserDeepsight, userHasRoleInpulse } from '@commons/utils/roles';

export const getListActions = ({
  filteredInternalInvoices,
  selectedInternalInvoices,
  handleExportPDF,
  handleExportXLS,
  goToCreateInvoice,
  currency,
}) => {
  const areItemsSelected = !isEmpty(selectedInternalInvoices);

  const actions = [
    {
      id: 'create',
      actionLabel: i18next.t('INVOICE.INVOICE_CONTROLS.INVOICE_CONTROLS_ACTION_NEW_CONTROL'),
      fixed: true,
      handleAction: () => {},
      render: () => (
        <Button
          color={'inpulse-default'}
          handleClick={goToCreateInvoice}
          icon="/images/inpulse/add-white-small.svg"
          label={i18next.t('GENERAL.CREATE')}
        />
      ),
    },
    {
      id: 'export_list',
      actionLabel: i18next.t(areItemsSelected ? 'GENERAL.EXPORT_SELECTION' : 'GENERAL.EXPORT_LIST'),
      actionIcon: () => '/images/inpulse/file-download-black-small.svg',
      handleAction: () =>
        handleExportXLS(
          areItemsSelected ? selectedInternalInvoices : filteredInternalInvoices,
          currency,
        ),
    },
    {
      id: 'export-pdf',
      actionLabel: i18next.t('INVOICE.INTERNAL_INVOICES.EXPORT_TO_PDF'),
      handleAction: () =>
        handleExportPDF(areItemsSelected ? selectedInternalInvoices : filteredInternalInvoices),
      actionIcon: () => '/images/inpulse/file-download-black-small.svg',
    },
  ];

  return actions;
};

export const getRowActions = ({ user, handleExportPDF, handleDeleteById }) => {
  const isInpulseUser = userHasRoleInpulse(user) && isUserDeepsight(user);

  return [
    {
      id: 'export-pdf',
      actionLabel: () => i18next.t('INVOICE.INTERNAL_INVOICES.DOWNLOAD'),
      actionIcon: () => '/images/inpulse/file-download-black-small.svg',
      handleAction: (item) => handleExportPDF([item]),
    },
    {
      id: 'delete',
      actionLabel: () => i18next.t('INVOICE.INTERNAL_INVOICES.ACTION_DELETE_INVOICE'),
      actionIcon: () => '/images/inpulse/delete-ip-black-small.svg',
      handleAction: ({ id }) => handleDeleteById(id),
      isHighlighted: () => true,
      isHidden: () => !isInpulseUser,
    },
  ];
};

export default {
  getListActions,
  getRowActions,
};
